// import moment from 'moment'
import {
  format,
  startOfMonth,
  endOfMonth,
  getISODay,
  addDays,
  getDaysInMonth,
  subMonths,
  subDays,
  addMonths
} from 'date-fns'
import axios from 'axios';
import miniToastr from 'mini-toastr';

import configAll from '../../../../config/index.cjs'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']
// url and endpoint constants
const API_URL = config.urlServer
const ARTICLE_URL = `${API_URL}api/ppa/article/`
const ANSWER_URL = `${API_URL}api/per/everydayanswers/`

export default {
  namespaced: true,
  state: {
    monthDays: [],
    currentYear: format(new Date(), 'yyyy'),
    currentMonth: format(new Date(), 'MM'),
    currentDay: format(new Date(),'dd'),
    thisYear: format(new Date(), 'yyyy'),
    thisMonth: format(new Date(), 'MM'),
    thisDay: format(new Date(),'dd'),
    thisDate: new Date(),
    currentDate: new Date(),
    articleCalendar: [],
    answerCalendar: [],
    simpleCalendar: []
  },
  mutations: {
    setSimpleCalendar(state, items) {
      // eslint-disable-next-line
      state.simpleCalendar = items
    },
    setArticleCalendar(state, items) {
      // console.log(items.days);
      let days = [];
      items.days.forEach((itemday) => {
        days.push(itemday.days);
        // tags.push(tag.title)
        // state.tags.push({ text: tag.title })
      })

      let arr = getCalDays(items.dateContext, days, 1)
      // console.log(days);
      // let arr = getCalDays(dateContext)
      // eslint-disable-next-line
      state.articleCalendar = arr
    },
    setAnswerCalendar(state, items) {
      // console.log(items.days);
      let days = [];
      items.days.forEach((itemday) => {
        days.push(itemday.days);
        // tags.push(tag.title)
        // state.tags.push({ text: tag.title })
      })

      let arr = getCalDays(items.dateContext, days, 1)
      // console.log(days);
      // let arr = getCalDays(dateContext)
      // eslint-disable-next-line
      state.answerCalendar = arr
    },
    getMonthDays (state, dateContext) {
      const newDate = dateContext
      // eslint-disable-next-line
      // console.log(dateContext);
      // const newDate = dateContext.clone()
      // const newDate1 = dateContext.clone()
      // const dd3 = dateContext.clone()
      // eslint-disable-next-line
      // console.log(dateContext);
      const currentMonth = startOfMonth(new Date(newDate))
      // eslint-disable-next-line
      // console.log(currentMonth);
      const beginCurrentMonthDay = getISODay(new Date(currentMonth))
      let getPrevDays
      if (beginCurrentMonthDay === 1) {
        getPrevDays = 7
      } else {
        getPrevDays = beginCurrentMonthDay - 1
      }
      const prevMonth = subMonths(new Date(newDate), 1)
      const arr = []
      let xx1 = endOfMonth(new Date(prevMonth))
      for (let i = 0; i < getPrevDays; i += 1) {
        const obj = {
          date: new Date(xx1),
          date1: format(xx1, 'MM-dd-yyyy'),
          day: format(xx1, 'd'),
          weekDay: getISODay(xx1),
          month: format(xx1,'MM'),
          isCurrentMonth: false,
          isCurrentDay: false,
          classes: `fc-${format(xx1,'ddd').toLowerCase()} fc-other-month fc-past`
        }
        arr.unshift(obj)
        xx1 = subDays(new Date(xx1), 1)
      }
      let xx2 = startOfMonth(new Date(currentMonth))

      // const aa = moment();
      // eslint-disable-next-line
      // console.log(xx2);
      // // const bb = moment();
      // // eslint-disable-next-line
      // console.log(dateContext);
      for (let i = 0; i < getDaysInMonth(new Date(currentMonth)); i += 1) {
        // eslint-disable-next-line
        // console.log(xx2);
        const obj = {
          date: new Date(xx2),
          date1: format(xx2,'MM-dd-yyyy'),
          day: format(xx2, 'd'),
          weekDay: getISODay(xx2),
          month: format(xx2,'MM'),
          isCurrentMonth: true,
          isCurrentDay: format(xx2, 'dd-MM-yyyy') === format(new Date(), 'dd-MM-yyyy'),
          classes: `fc-${format(xx2,'ddd').toLowerCase()}`
        }
        if (obj.isCurrentDay) {
          obj.classes += ' fc-today fc-state-highlight'
        } else if (xx2.clone() < new Date()) {
          obj.classes += ' fc-past'
        } else {
          obj.classes += ' fc-future'
        }
        arr.push(obj)
        xx2 = addDays(xx2, 1)
      }

      let getNextDays
      const endCurrentMonthDay = getISODay(new Date(endOfMonth(newDate)))
      if (endCurrentMonthDay === 7) {
        getNextDays = 7
      } else {
        getNextDays = 7 - endCurrentMonthDay
      }
      const nextMonth = addMonths(newDate, 1)
      let xx3 = startOfMonth(new Date(nextMonth))
      for (let i = 0; i < getNextDays; i += 1) {
        const obj = {
          date: new Date(xx3),
          date1: format(xx3,'MM-dd-yyyy'),
          day: format(xx3,'d'),
          weekDay: getISODay(xx3),
          month: format(xx3,'MM'),
          isCurrentMonth: false,
          isCurrentDay: false,
          classes: `fc-${format(xx3,'ddd').toLowerCase()} fc-other-month fc-future`
        }
        arr.push(obj)
        xx3 = xx3.add(1, 'days')
      }

      // eslint-disable-next-line
      state.monthDays = arr;
      // eslint-disable-next-line
      state.currentMonth =  format(new Date(this.date), 'MM');
      // eslint-disable-next-line
      state.currentDay =  format(new Date(this.date), 'dd');
      // eslint-disable-next-line
      // state.selectedDay = moment(this.date).format('DD');
    },
    setCurrentDates (state, obj) {
      // eslint-disable-next-line
      state.currentYear = obj.year;
      // eslint-disable-next-line
      state.currentMonth = obj.month;
      // eslint-disable-next-line
      if (obj.year === state.thisYear && obj.month === state.thisMonth) {
        // eslint-disable-next-line
        state.currentDay = state.thisDay;
      } else {
        // eslint-disable-next-line
        state.currentDay = '01';
      }
      // eslint-disable-next-line
      state.currentDate = new Date(`${state.currentYear}-${state.currentMonth}-${state.currentDay}`);
    }
  },
  actions: {
    setCurrentDates ({ commit }, obj) {
      // console.log(obj.month);
      if (!obj.month) {
        // eslint-disable-next-line
        obj.month = format(new Date(),'MM');
        // eslint-disable-next-line
        obj.year = format(new Date(),'yyyy');
      }
      commit('setCurrentDates', obj)
    },
    getMonthDays ({ commit }, dateContext) {
      commit('getMonthDays', dateContext)
    },
    calculateMonthTable ({ commit }, dateContext) {
      let arr = getCalDays(dateContext)

      commit('setSimpleCalendar', arr)

    },
    articleMonthTable({ commit, rootState }, dateContext){
      const fromDate = encodeURI(format(startOfMonth(new Date(dateContext)), 'yyyy-MM-dd HH:mm:ss').toString())
      const endDate = encodeURI(format(endOfMonth(new Date(dateContext)), 'yyyy-MM-dd HH:mm:ss').toString())

      // let fromDate = encodeURI(moment(dateContext).startOf('month').format('YYYY-MM-DD HH:mm:ss').toString());
      // let endDate = encodeURI(moment(dateContext).endOf('month').format('YYYY-MM-DD HH:mm:ss').toString());
      axios.get(`${ARTICLE_URL.replace('ppa', rootState.account.ppa)}days?fromDate=${fromDate}&endDate=${endDate}`)
        .then((response) => {


          // console.log(response.data);
          // eslint-disable-next-line
          commit('setArticleCalendar', { days: response.data, dateContext} );
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Article Calendar failed!', 1500);
        })
    },
    answerMonthTable({ commit }, dateContext){
      const fromDate = encodeURI(format(startOfMonth(new Date(dateContext)), 'yyyy-MM-dd HH:mm:ss').toString())
      const endDate = encodeURI(format(endOfMonth(new Date(dateContext)), 'yyyy-MM-dd HH:mm:ss').toString())

      // let fromDate = encodeURI(moment(dateContext).startOf('month').format('YYYY-MM-DD HH:mm:ss').toString());
      // let endDate = encodeURI(moment(dateContext).endOf('month').format('YYYY-MM-DD HH:mm:ss').toString());
      axios.get(`${ANSWER_URL}days?fromDate=${fromDate}&endDate=${endDate}`)
        .then((response) => {


          // console.log(response.data);
          // eslint-disable-next-line
          commit('setAnswerCalendar', { days: response.data, dateContext} );
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Answer Calendar failed!', 1500);
        })
    },
  },
  getters: {
    currentYear (state) {
      return state.currentYear
    },
    currentMonth (state) {
      return state.currentMonth
    },
    currentDay (state) {
      return state.currentDay
    },
    thisYear (state) {
      return state.thisYear
    },
    thisMonth (state) {
      return state.thisMonth
    },
    thisDay (state) {
      return state.thisDay
    },
    thisDate (state) {
      return state.thisDate
    },
    currentDate (state) {
      return state.currentDate
    }
  }
}

function getCalDays(dateContext, selectedDays =[], article =0) {
  const newDate = dateContext
  // const newDate1 = dateContext.clone()
  // const dd3 = dateContext.clone()
  // eslint-disable-next-line
  // console.log(dateContext);
  const currentMonth = startOfMonth(new Date(newDate))

  // eslint-disable-next-line
  // console.log(currentMonth);
  const beginCurrentMonthDay = getISODay(new Date(currentMonth))
  let getPrevDays
  if (beginCurrentMonthDay === 1) {
    getPrevDays = 7
  } else {
    getPrevDays = beginCurrentMonthDay - 1
  }
  const prevMonth = subMonths(new Date(newDate), 1)
  //console.log(prevMonth)
  const arr = []
  let xx1 = endOfMonth(new Date(prevMonth))
  for (let i = 0; i < getPrevDays; i += 1) {
    // console.log(xx1)
    // console.log(format(xx1, 'MM-dd-yyyy'))
    const obj = {
      date: new Date(xx1),
      date1: format(xx1, 'MM-dd-yyyy'),
      day: format(xx1, 'd'),
      weekDay: getISODay(xx1),
      month: format(xx1,'MM'),
      isCurrentMonth: false,
      isCurrentDay: false,
      classes: `fc-${format(xx1,'ddd').toLowerCase()} fc-other-month fc-past`
    }
    arr.unshift(obj)
    xx1 = subDays(new Date(xx1), 1)
  }
  let xx2 = startOfMonth(new Date(currentMonth))


  for (let i = 0; i < getDaysInMonth(new Date(currentMonth)); i += 1) {
    // eslint-disable-next-line
    // console.log(xx2);
    const obj = {
      date: new Date(xx2),
      date1: format(xx2,'MM-dd-yyyy'),
      day: format(xx2, 'd'),
      weekDay: getISODay(xx2),
      month: format(xx2,'MM'),
      isCurrentMonth: true,
      isCurrentDay: format(xx2, 'dd-MM-yyyy') === format(new Date(), 'dd-MM-yyyy'),
      isSelectedDay: selectedDays.includes(parseInt(format(new Date(xx2), 'dd'))),
      classes: `fc-${format(xx2,'ddd').toLowerCase()}`
    }

    // if ((selectedDays.includes(parseInt(xx2.clone().format('DD')))) ) {
    //   console.log('ooo');
    // }
    //console.log(parseInt(xx2.clone().format('DD')))
    if (article) {
      if (obj.isSelectedDay) {
        obj.classes += ' fc-today fc-state-highlight'
      } else {
        obj.classes += ' fc-past'
      }
    } else {
      if (obj.isCurrentDay ) {
        obj.classes += ' fc-today fc-state-highlight'
      } else if (xx2 < new Date()) {
        obj.classes += ' fc-past'
      } else {
        obj.classes += ' fc-future'
      }
    }

    arr.push(obj)
    xx2 = addDays(xx2, 1)
  }

  let getNextDays
  const endCurrentMonthDay = getISODay(new Date(endOfMonth(newDate)))
  if (endCurrentMonthDay === 7) {
    getNextDays = 7
  } else {
    getNextDays = 7 - endCurrentMonthDay
  }
  const nextMonth = addMonths(newDate, 1)
  let xx3 = startOfMonth(new Date(nextMonth))
  for (let i = 0; i < getNextDays; i += 1) {
    const obj = {
      date: new Date(xx3),
      date1: format(xx3,'MM-dd-yyyy'),
      day: format(xx3,'d'),
      month: format(xx3,'MM'),
      weekDay: getISODay(xx3),
      isCurrentMonth: false,
      isCurrentDay: false,
      classes: `fc-${format(xx3,'ddd').toLowerCase()} fc-other-month fc-future`
    }
    arr.push(obj)
    xx3 = addDays(xx3, 1)
  }

  return arr
}

// function getCalDays(dateContext, selectedDays =[], article =0) {
//   const newDate = dateContext.clone()
//   const newDate1 = dateContext.clone()
//   const dd3 = dateContext.clone()
//   // eslint-disable-next-line
//   // console.log(dateContext);
//   const currentMonth = dd3.startOf('month')
//   // eslint-disable-next-line
//   // console.log(currentMonth);
//   const beginCurrentMonthDay = currentMonth.clone().isoWeekday()
//   let getPrevDays
//   if (beginCurrentMonthDay === 1) {
//     getPrevDays = 7
//   } else {
//     getPrevDays = beginCurrentMonthDay - 1
//   }
//   const prevMonth = newDate.subtract(1, 'months')
//   const arr = []
//   let xx1 = prevMonth.endOf('month')
//   for (let i = 0; i < getPrevDays; i += 1) {
//     const obj = {
//       date: xx1,
//       date1: xx1.format('MM-DD-YYYY'),
//       day: xx1.format('D'),
//       weekDay: xx1.isoWeekday(),
//       isCurrentMonth: false,
//       isCurrentDay: false,
//       classes: `fc-${xx1.format('ddd').toLowerCase()} fc-other-month fc-past`
//     }
//     arr.unshift(obj)
//     xx1 = xx1.subtract(1, 'days')
//   }
//   let xx2 = currentMonth.clone().startOf('month')
//
//
//   for (let i = 0; i < currentMonth.clone().daysInMonth(); i += 1) {
//     // eslint-disable-next-line
//     // console.log(xx2);
//     const obj = {
//       date: xx2.clone(),
//       date1: xx2.clone().format('MM-DD-YYYY'),
//       day: xx2.clone().format('D'),
//       weekDay: xx2.clone().isoWeekday(),
//       isCurrentMonth: true,
//       isCurrentDay: xx2.clone().format('DD-MM-YYYY') === moment().format('DD-MM-YYYY'),
//       isSelectedDay: selectedDays.includes(parseInt(xx2.clone().format('DD'))),
//       classes: `fc-${xx2.clone().format('ddd').toLowerCase()}`
//     }
//
//     // if ((selectedDays.includes(parseInt(xx2.clone().format('DD')))) ) {
//     //   console.log('ooo');
//     // }
//     //console.log(parseInt(xx2.clone().format('DD')))
//     if (article) {
//       if (obj.isSelectedDay) {
//         obj.classes += ' fc-today fc-state-highlight'
//       } else {
//         obj.classes += ' fc-past'
//       }
//     } else {
//       if (obj.isCurrentDay ) {
//         obj.classes += ' fc-today fc-state-highlight'
//       } else if (xx2.clone() < moment()) {
//         obj.classes += ' fc-past'
//       } else {
//         obj.classes += ' fc-future'
//       }
//     }
//
//     arr.push(obj)
//     xx2 = xx2.add(1, 'days')
//   }
//
//   let getNextDays
//   const endCurrentMonthDay = moment(dd3.clone().endOf('month')).isoWeekday()
//   if (endCurrentMonthDay === 7) {
//     getNextDays = 7
//   } else {
//     getNextDays = 7 - endCurrentMonthDay
//   }
//   const nextMonth = newDate1.clone().add(1, 'months')
//   let xx3 = moment(nextMonth).startOf('month')
//   for (let i = 0; i < getNextDays; i += 1) {
//     const obj = {
//       date: xx3.clone(),
//       date1: xx3.clone().format('MM-DD-YYYY'),
//       day: xx3.clone().format('D'),
//       weekDay: xx3.clone().isoWeekday(),
//       isCurrentMonth: false,
//       isCurrentDay: false,
//       classes: `fc-${xx3.clone().format('ddd').toLowerCase()} fc-other-month fc-future`
//     }
//     arr.push(obj)
//     xx3 = xx3.add(1, 'days')
//   }
//
//   return arr
// }